
import { Client, SocialProfiles } from "../../types";
import { Badge } from "@/components/ui/badge";
import { Code } from "lucide-react";
import { FieldIndicator } from "./FieldIndicator";
import { SocialLink } from "./SocialLink";

interface SocialMediaTechnologySectionProps {
  client: Client;
  fieldsWithNewData: Set<keyof Client>;
}

export const SocialMediaTechnologySection: React.FC<SocialMediaTechnologySectionProps> = ({
  client,
  fieldsWithNewData,
}) => {
  const socialPlatforms = client.social_profiles ? Object.keys(client.social_profiles) : [];
  const hasNewSocialProfiles = fieldsWithNewData.has('social_profiles');
  const hasNewTechnologiesUsed = fieldsWithNewData.has('technologies_used');
  const showSection = (socialPlatforms.length > 0 || (client.technologies_used && client.technologies_used.length > 0) || hasNewSocialProfiles || hasNewTechnologiesUsed);

  if (!showSection) return null;

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-800 dark:text-slate-200 border-b pb-2">Social Media & Technology</h3>
      {(socialPlatforms.length > 0 || hasNewSocialProfiles) && (
        <div>
          <h4 className="text-sm font-medium text-muted-foreground mb-1 flex items-center">
            Social Profiles
            <FieldIndicator fieldName="social_profiles" fieldsWithNewData={fieldsWithNewData} />
          </h4>
          <div className="flex flex-wrap gap-x-4 gap-y-2">
            {socialPlatforms.map(platform => (
              client.social_profiles && <SocialLink key={platform} platform={platform} url={(client.social_profiles as SocialProfiles)[platform]} />
            ))}
          </div>
        </div>
      )}
      {((client.technologies_used && client.technologies_used.length > 0) || hasNewTechnologiesUsed) && (
        <div className="mt-4">
          <h4 className="text-sm font-medium text-muted-foreground mb-1 flex items-center">
            <Code className="w-4 h-4 mr-2 text-invenio-primary" />
            Technologies Used
            <FieldIndicator fieldName="technologies_used" fieldsWithNewData={fieldsWithNewData} />
          </h4>
          <div className="flex flex-wrap gap-2">
            {client.technologies_used?.map((tech, index) => (
              <Badge key={index} variant="secondary">{tech}</Badge>
            ))}
            {!client.technologies_used && hasNewTechnologiesUsed && <p className="text-sm">Data available</p>}
          </div>
        </div>
      )}
    </div>
  );
};
